import { createApi, createDomain } from 'effector';
import produce, { type Draft } from 'immer';
import { createGate } from 'effector-react';
import type {
  GeneralID,
  ComponentLayer,
  ComponentLayerAnimationCategory,
} from '@types';

const domain = createDomain('editingLayer');

export interface EditingCLayerStore {
  /** 确保编辑中的是完整的数据(补齐后期版本增加的字段) */
  layer: Required<ComponentLayer>;
  sceneId: GeneralID;
  isNew?: boolean;
}

export const $editingComponentLayer = domain.store<EditingCLayerStore | null>(
  null
);
export const $editingComponentLayerApi = createApi($editingComponentLayer, {
  set: (state, payloed: EditingCLayerStore | null) => payloed,
  clear: () => null,
  update: (
    state,
    updater: (draft: Draft<ComponentLayer>) => ComponentLayer | void
  ) => {
    if (!state) return state;
    const newData = produce(state.layer, updater);
    return { ...state, layer: newData };
  },
});

export const $componentLayerBatchSelected = domain.store<Set<string>>(
  new Set()
);
export const $componentLayerBatchSelectedApi = createApi(
  $componentLayerBatchSelected,
  {
    clear: () => new Set(),
    set: (_, payload: Set<string>) => payload,
    select: (state, id: string) => {
      const newState = new Set(state);
      if (newState.has(id)) {
        newState.delete(id);
      } else {
        newState.add(id);
      }
      return newState;
    },
  }
);

/**
 * 当前编辑的动画 tab
 */
export const $GateLayerAnimationTab =
  createGate<ComponentLayerAnimationCategory | null>({
    defaultState: null,
    domain,
  });

export const onLayerAnimationPreview = domain.event();
